<template>
  <div class="measurements-index-list">

    <nuttrema-loader v-show="isLoading"></nuttrema-loader>

    <nuttrema-empty-result v-show="isEmpty"></nuttrema-empty-result>

    <nuttrema-empty-result v-show="state.error" icon="fa fa-space-shuttle">
      <template slot="text">
        <h1 v-html="$t('label.error_loading_text')"></h1>
        <h4 v-html="$t('label.error_loading_error_text')"></h4>
      </template>
    </nuttrema-empty-result>

    <ul>
      <li
         v-if="group.length > 0"
         v-for="(group, key) in list"
         class="nuttrema-list-item"
        :key="group.code">
          <h4 class="nuttrema-list-item__title">{{ $t(`label.${key}`) }}</h4>
          <measurements-index-list-item
             v-for="measurement in group"
            :key="measurement.id"
            :meta="meta"
            :edit="edit"
            :measurement="measurement">
          </measurements-index-list-item>
        </li>
    </ul>
  </div>
</template>

<script>
import { assign, isEmpty, isNull, orderBy, first, each, pickBy } from 'lodash';

import moment from 'moment';

import VirtualGrouping from 'components/mixins/virtual-grouping';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';
import NuttremaEmptyResult from 'components/ui/panels/nuttrema-empty-result';

import MeasurementsIndexListItem from './cmpt-measurements-index-list-item';

export default {
  name: 'measurements-index-list',
  mixins: [VirtualGrouping],
  props: {
    state: {
      type: Object,
      required: true,
      default: null,
    },
    meta: {
      required: true,
      default: null,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    period: {
      type: String,
      required: false,
      default: null,
    },
    dateFrom: {
      required: false,
      default: null,
    },
    dateTo: {
      required: false,
      default: null,
    },
  },
  components: {
    MeasurementsIndexListItem,
    NuttremaLoader,
    NuttremaEmptyResult,
  },
  methods: {
    groupByDate(items, key) {
      const today = moment().startOf('day');
      const startOfWeek = moment().startOf('isoWeek');
      const endOfWeek = moment().endOf('isoWeek');
      const startOfMonth = moment().startOf('month');
      const endOfMonth = moment().endOf('month');

      const groups = {
        not_defined: [],
        today: [],
        this_week: [],
        previous_week: [],
        this_month: [],
        after_this_month: [],
        before_this_month: [],
      };

      each(items, (item) => {
        let group = 'not_defined';
        const current = moment(item[key]);

        if (current.isAfter(endOfMonth)) group = 'after_this_month';
        else if (current.isBetween(today, endOfWeek, null, '[]')) group = 'today';
        else if (current.isBetween(startOfWeek, endOfWeek, null, '[]')) group = 'this_week';
        else if (current.isBetween(startOfMonth, endOfMonth, null, '[]')) group = 'this_month';
        else if (current.isBefore(startOfMonth)) group = 'before_this_month';

        groups[group].push(item);
      });

      return pickBy(groups, group => group.length > 0);
    },
    order() {
      return orderBy(this.state.data.list, [item => new Date(item.measurement_timestamp)], ['desc']);
    },
  },
  computed: {
    isEmpty() {
      return isNull(this.state.error) && isEmpty(this.state.data.list) && !this.state.fetching && this.state.fetched;
    },
    isLoading() {
      return isNull(this.state.error) && this.state.fetching && !this.state.fetched;
    },
  },
  created() {
    const groupingList = [
      { label: 'Date', type: 'date', key: 'measurement_date' },
    ];
    assign(this.grouping, {
      list: groupingList,
      selected: first(groupingList),
    });
  },
};
</script>

<style lang="scss">
  @import "~styles/theme/colors";
  @import "~styles/component/nuttrema-list-item";
  .measurements-index-list {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
    overflow-y: auto;
    align-self: stretch;
    flex-direction: column;
    background-color: $index-list-bg;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/dashboard/cmpt-measurements-index-list.vue